import React from 'react';
import { LoadingProps } from '../../models/types';

const LoadingSpinner: React.FC<LoadingProps> = ({ size = 'medium', text, className = '' }) => {

  return (
    <div className={`d-flex flex-column align-items-center justify-content-center ${className}`}
      style={{ minHeight: '150px' }}>
      <img src={require('../../assets/images/ZdPH.gif')} alt="Loading" style={{ width: 64, height: 64, marginBottom: 12 }} />
      {text && <span className="ms-2">{text}</span>}
    </div>
  );
};

export default LoadingSpinner; 